export default {
    // 产品分类列表
    list: {
        method: 'get',
        url: '/product_categories'
    },
    // 产品分类新增
    add: {
        method: 'post',
        url: '/product_categories'
    },
    // 产品分类更新
    edit: {
        method: 'patch',
        url: '/product_categories/:id'
    },
    // 产品分类详情
    detail: {
        method: 'get',
        url: '/product_categories/:id'
    },
    // 产品分类操作人列表
    operators: {
        method: 'get',
        url: '/product_categories/operators'
    },
    // 产品服务项列表
    serviceItemsList: {
        method: 'get',
        url: '/product_categories/:id/service_items'
    },
    // 产品服务项新增
    addServiceItems: {
        method: 'post',
        url: '/product_categories/:id/service_items'
    },
    // 产品分类更新
    editServiceItems: {
        method: 'patch',
        url: '/product_categories/:id/service_items/:sid'
    },
    // 产品分类详情
    serviceItemsDetail: {
        method: 'get',
        url: '/product_categories/:id/service_items/:sid'
    },
    // 产品规格项列表
    specsList: {
        method: 'get',
        url: '/product_categories/:id/standards'
    },
    // 产品规格项新增
    addSpecs: {
        method: 'post',
        url: '/product_categories/:id/standards'
    },
    // 产品规格更新
    editSpecs: {
        method: 'patch',
        url: '/product_categories/:id/standards/:sid'
    },
    // 产品规格详情
    specsDetail: {
        method: 'get',
        url: '/product_categories/:id/standards/:sid'
    },
    productsDetail: {
        method: 'get',
        url: '/products'
    },
    editProducts: {
        method: 'patch',
        url: '/products'
    },
    pricesList: {
        method: 'get',
        url: '/product/:id/prices'
    },
    editPrices: {
        method: 'patch',
        url: '/product/:id/prices'
    },
};



// WEBPACK FOOTER //
// ./src/api/product-categorys.js